import { useCallback, useState } from "react";
import { toast } from "sonner";
import { downloadStandardTemplate } from "@/api/client";
import { useT } from "@/lib/translation";

export function useDownloadTemplate() {
  const t = useT();
  const [isDownloadingTemplate, setIsDownloadingTemplate] = useState(false);

  const handleDownloadTemplate = useCallback(async () => {
    try {
      setIsDownloadingTemplate(true);
      const blob = await downloadStandardTemplate();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "standard_template.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success(t("import:templateDownload.started"));
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : t("import:templateDownload.failed");
      toast.error(message);
    } finally {
      setIsDownloadingTemplate(false);
    }
  }, [t]);

  return { handleDownloadTemplate, isDownloadingTemplate };
}
